export const CAN_SCALE = {
  masterTableName: "MC_CAN_SCALE",
  tableName: "MC_CAN_SCALE_DETAILS",
  columnName: "CS_ID",
  columnValue: 0,
  title: "can-scale.title",
  rows: [
    { title: "id", value: "ID" },
    { title: "date", value: "CTIME", headerName: "Tarih", type: "date" },
    { title: "hair", value: "HAIR_XNAME" },
    { title: "cheek", value: "CHEEK_XNAME" },
    { title: "chin_and_neck", value: "CHIN_AND_NECK_XNAME" },
    { title: "arm", value: "ARM_XNAME" },
    { title: "back", value: "BACK_XNAME" },
    { title: "hip", value: "HIP_XNAME" },
    { title: "leg", value: "LEG_XNAME" },
    { title: "rib_cage", value: "RIB_CAGE_XNAME" },
    { title: "abdominal_skin", value: "ABDOMINAL_SKIN_XNAME" },
    { title: "score", value: "SCORE" },
    { title: "note", value: "NOTE" },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "hair", headerName: "can-scale.hair", flex: 1 },
    { field: "cheek", headerName: "can-scale.cheek", flex: 1 },
    {
      field: "chin_and_neck",
      headerName: "can-scale.chin-and-neck",
      flex: 1,
    },
    { field: "arm", headerName: "can-scale.arm", flex: 1 },
    { field: "back", headerName: "can-scale.back", flex: 1 },
    { field: "hip", headerName: "can-scale.hip", flex: 1 },
    { field: "leg", headerName: "can-scale.leg", flex: 1 },
    { field: "rib_cage", headerName: "can-scale.rib-cage", flex: 1 },
    {
      field: "abdominal_skin",
      headerName: "can-scale.abdominal-skin",
      flex: 1,
    },
    {
      field: "score",
      headerName: "score",
      flex: 1,
      computed: true,

      calculate: (row: any) => {
        const keys = [
          "HAIR_XVALUE",
          "CHEEK_XVALUE",
          "CHIN_AND_NECK_XVALUE",
          "ARM_XVALUE",
          "BACK_XVALUE",
          "HIP_XVALUE",
          "LEG_XVALUE",
          "RIB_CAGE_XVALUE",
          "ABDOMINAL_SKIN_XVALUE",
        ];

        return keys.reduce((sum, key) => sum + (Number(row[key]) || 0), 0);
      },
    },
    { field: "note", headerName: "note", flex: 1 },
  ],
  mcpConfig: {
    HAIR: { mcpId: 607, field: "HAIR", scoreField: "HAIR_XNAME" },
    CHEEK: { mcpId: 608, field: "CHEEK", scoreField: "CHEEK_XNAME" },
    CHIN_AND_NECK: {
      mcpId: 609,
      field: "CHIN_AND_NECK",
      scoreField: "CHIN_AND_NECK_XNAME",
    },
    ARM: { mcpId: 610, field: "ARM", scoreField: "ARM_XNAME" },
    BACK: { mcpId: 611, field: "BACK", scoreField: "BACK_XNAME" },
    HIP: { mcpId: 612, field: "HIP", scoreField: "HIP_XNAME" },
    LEG: { mcpId: 613, field: "LEG", scoreField: "LEG_XNAME" },
    RIB_CAGE: { mcpId: 614, field: "RIB_CAGE", scoreField: "RIB_CAGE_XNAME" },
    ABDOMINAL_SKIN: {
      mcpId: 615,
      field: "ABDOMINAL_SKIN",
      scoreField: "ABDOMINAL_SKIN_XNAME",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    CS_ID: "",
    CUSER: "",
    CTIME: new Date(),
    HAIR: "",
    CHEEK: "",
    CHIN_AND_NECK: "",
    ARM: "",
    BACK: "",
    HIP: "",
    LEG: "",
    RIB_CAGE: "",
    ABDOMINAL_SKIN: "",
    SCORE: 0,
    NOTE: "",
  },

  chartScoreField: "SCORE",
  chartTimeField: "CTIME",
};
